<template>
  <div class="text-left container-fluid">
    <SectionHeader title="report"/>

    <div class="row">
      <div class="text-center col-sm order-1">
        from: <span class="fw-bold">{{formatTimestamp(report.startTs, 'LLLL')}}</span>
      </div>
      <div class="text-center col-sm order-2">
        to: <span class="fw-bold">{{formatTimestamp(report.endTs, 'LLLL')}}</span>
      </div>
    </div>
    <div class="row">
      <div class="text-center col-sm order-3">
        overall uptime: <span class="fw-bold">{{formatPercentage(report.uptimePerc)}}</span>
      </div>
      <div class="text-center col-sm order-4">
        number of base stations: <span class="fw-bold">{{report.lrrList.length}}</span>
      </div>
    </div>
    <BaseStationReport v-for="bssReport of report.lrrList" :key="bssReport.lrrId" :bss-report="bssReport"/>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { NetworkUptimeReport } from '@/types';
import SectionHeader from '@/components/SectionHeader.vue';
import BaseStationReport from '@/components/reports/BaseStationReport.vue';
import * as FilterUtil from '@/util/FilterUtil';

interface Props {
  report: NetworkUptimeReport;
}

withDefaults(defineProps<Props>(), {
  report: () => ({}) as NetworkUptimeReport
});

const formatPercentage = (value: number) => FilterUtil.percentage(value)
const formatTimestamp = (ts: number, format?: string) => FilterUtil.tsToString(ts, format)

onMounted(() => {
  // Component mounted
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


</style>
